module.exports = __webpack_public_path__ + "static/img/2.3e0f415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R32/2.jpg
// module id = j7+9
// module chunks = 1